import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth, } from 'config/firebase';
import { Button, Col, Form, Image, Input, Row, Spin, Typography } from 'antd';
import { LeftOutlined } from "@ant-design/icons"
// assets
import LoginImage from "assets/images/signup.svg";
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography
const initialState = { email: "", }

export default function ForgetPassword() {
    const navigate = useNavigate()
    const [state, setState] = useState(initialState)
    const [isProcessing, setIsProcessing] = useState(false)

    const handleChange = e => setState(s => ({ ...s, [e.target.name]: e.target.value }))

    const handleSubmit = (e) => {
        e.preventDefault()
        const { email } = state
        setIsProcessing(true)
        sendPasswordResetEmail(auth, email)
            .then(() => {
                setIsProcessing(false)
                navigate("/auth/login")
                return window.toastify("Password Reset Email successfully sent", 'success')
            })
            .catch((error) => {
                const errorCode = error.code;
                let errorMessage
                switch (errorCode) {
                    case 'auth/email-already-in-use': return errorMessage = "An account with this email already exists. Please log in.";
                    case 'auth/invalid-email': return errorMessage = "The email address is not valid.";
                    case 'auth/operation-not-allowed': return errorMessage = "Email/password accounts are not enabled. Please contact support.";
                    case 'auth/weak-password': return errorMessage = "The password is too weak. Please choose a stronger password.";
                    default: errorMessage = "An error occurred during registration. Please try again.";
                }

                setIsProcessing(false)
                return window.toastify(errorMessage, 'error')
            })
    }

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <>
            <Row className="min-vh-100">
                <Col xs={24} md={12} lg={16} className="p-0 d-none d-md-block">
                    <Image src={LoginImage} alt="Krist brand image" preview={false} className="h-100 w-100 object-fit-cover" height={"100vh"} width={"100%"} />
                </Col>
                <Col xs={24} sm={{ span: 16, offset: 4 }} md={{ span: 12, offset: 0 }} lg={8} className="d-flex flex-column justify-content-center p-4 p-md-5">
                    <div className="text-center text-md-start mb-3">
                        <Title level={4} className='fw-bold' onClick={handleGoBack} style={{ cursor: "pointer" }}><LeftOutlined /> Back</Title>
                    </div>
                    <div className="text-center text-md-start mb-3">
                        <Title level={2} className='fw-bold mb-0'>Forgot Password</Title>
                        <Text className='text-muted'> Enter your registered email address. we'll send you a code to reset your password. </Text>
                    </div>

                    <Form className="w-100" layout='vertical' onSubmitCapture={handleSubmit}>
                        <Form.Item label="Email Address" className='mb-3 p-0'>
                            <Input type='email' placeholder='Enter your Email' className=' w-100' name='email' onChange={handleChange} size='large' />
                        </Form.Item>
                        <div className="d-flex justify-content-center align-items-center mt-2 w-100">
                            <Button type="primary" htmlType="submit" className='w-100 bg-dark' size='large' disabled={isProcessing} classNames={"text-white"}>
                                {isProcessing ? <Spin className='text-white' /> : "Send Email"}
                            </Button>
                        </div>
                    </Form>
                </Col>
            </Row>
        </>
    );
}
